import type { ReactElement } from 'react';
import cx from 'clsx';
import { Input } from '#components/form-elements/input/input';
import { SearchFieldBase, type SearchFieldBaseProps } from './search-field-base';
import styles from './search-field.module.css';

export interface SearchFieldComponentProps extends Omit<
  SearchFieldBaseProps,
  'inputSlot' | 'closeIcon' | 'iconClassName' | 'closeClassName' | 'spinnerClassName'
> {
  compact?: boolean;
  inputClassName?: string;
}

export function SearchField({
  placeholder,
  className,
  compact,
  inputClassName,
  showLoading,
  ...props
}: SearchFieldComponentProps): ReactElement {
  return (
    <SearchFieldBase
      placeholder={placeholder}
      className={cx(className, styles.container)}
      iconClassName={styles.icon}
      closeClassName={styles.close}
      spinnerClassName={styles.spinner}
      showLoading={showLoading}
      inputSlot={
        <Input
          autoFocus={props.autoFocus}
          className={cx(styles.input, compact && styles.compact, inputClassName)}
          data-test-search-input
          placeholder={placeholder}
        />
      }
      {...props}
    />
  );
}
